import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setFeatureState,
} from "../slices/erpFeaturesSlice";
import {
  CheckFeaturesResponse,
  FeatureConfigResponse,
  ErpAllFeatureKeys
} from "../models/erpFeature";
import { checkForFeatures } from "../services/erpFeatures";

export const useFetchErpFeatures = (debugFeatures?: string[]): {
  loading: boolean;
} => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const fetchErpFeatures = async (features: string[]) => {
    try {
      const response = await checkForFeatures(features);
      Object.keys(response).forEach((featureKey) => {
        const key = featureKey as keyof CheckFeaturesResponse;
        const featureResponse: FeatureConfigResponse | {} = response[key] || {};

        if (Object.keys(featureResponse).length === 0) {
          return;
        }

        const { value, params = {} } = featureResponse as FeatureConfigResponse;
        dispatch(
          setFeatureState({
            feature: key,
            isEnabled: value || false,
            params,
          }),
        );
      });
    } catch (error) {
      console.error({ fetchERpFeaturesError: error });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const featuresToFetch = debugFeatures ?? ErpAllFeatureKeys;

    fetchErpFeatures(featuresToFetch);
  }, []);

  return { loading };
};